// Wrapper for new and edit site modals launched from Study Locations tab
import { memo } from 'react';

// Components
import { PrimeButton } from 'components-design-system'
import Checkbox from 'components/Checkbox/Checkbox';
import './ModalHeaderActions.scss'

const ModalHeaderActions = ({
  onDelete,
  maskSettings,
  onChangeMaskSettings,
  permissions,
}) => {
  return <div className="study-loc-modal-header-actions">
    <div className="study-loc-modal-hed-checkboxes">
      <Checkbox
        style={{ margin: 0 }}
        checked={maskSettings?.facility_mask}
        onChange={e => onChangeMaskSettings("facility_mask", e)}
        label="Mask Address in CTG Submission" />
      <Checkbox
        style={{ margin: 0 }}
        checked={maskSettings?.contact_mask}
        onChange={e => onChangeMaskSettings("contact_mask", e)}
        label="Mask Contacts in CTG Submission" />
      <Checkbox
        style={{ margin: 0 }}
        checked={maskSettings?.investigator_mask}
        onChange={e => onChangeMaskSettings("investigator_mask", e)}
        label="Mask Investigators in CTG Submission" />
    </div>
    <div className="study-loc-modal-header-delete">
      {onDelete && permissions["study.site.delete"] &&
        <PrimeButton
          type="primary"
          icon={<i className="fas fa-trash-alt" />}
          danger
          onClick={onDelete}
        >
          Delete Site
        </PrimeButton>
      }
    </div>
  </div>
}

export default memo(ModalHeaderActions)